<template>
	<input type="checkbox" v-model="valueData" :value="data" class="form-check-input-styled" :name="name" data-fouc>
</template>
<script>

export default {
	props: {
        value: {
        	type: Boolean,
        	default : false
        },
        name: {
            required : true
        },
        data: {
            required : true
        }
    },
    data() {
		return {
			valueData : false,
			loaded : false
		}
	},
	watch: {
        valueData : function(value) {
            this.$emit('input', value)
        }
    },
	mounted () {
		this.initialize()
    },
    computed: {
    	isLoaded(){
    		return this.loaded
    	}
    },
    methods : {
    	initialize : function(){
    		this.valueData = this.value;
    		this.loaded = true;
    		$(this.$el).uniform();
    	}
    }
}
</script>